import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import PosHeader from "./components/PosHeader";
import ButtonsHeader from "./components/ButtonsHeader";
import AssessTop from "./components/AssessTop";
import Filters from "./components/Filters";
import Cards from "./components/Cards";
import DescriptionGame from "./components/DescriptionGame";
import AssessBottom from "./components/AssessBottom";
import Footer from "./components/Footer";
import NoMatch from "./components/NoMatch";

function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [cards, setCards] = useState([]);
  const [cardsToRender, setCardsToRender] = useState([]);
  const [allFilters, setAllFilters] = useState(true);
  const [filters, setFilters] = useState({
    category: {
      Energii: false,
      Akcija: false,
      Inovacii: false,
      Liderstvo: false,
      Tim: false,
    },
    timeFrame: {
      five_thirty_minutes: false,
      thirty_sixty_minutes: false,
      sixty_hundredandtwenty_minutes: false,
      hundredandtwenty_twohundredandfourty_minutes: false,
    },
    groupSize: { two_ten: false, ten_fourty: false, fourty_plus: false },
  });
  const [actualFilters, setActualFilters] = useState({
    category: {
      Енергии: false,
      Акција: false,
      Иновации: false,
      Лидерство: false,
      Тим: false,
    },
    timeFrame: {
      "5-30 минути": false,
      "30-60 минути": false,
      "60-120 минути": false,
      "120-240 минути": false,
    },
    groupSize: { "2-10": false, "10-40": false, "40+": false },
  });

  //fetch all the cards from the backend api
  useEffect(() => {
    fetch("https://brainsterboxapi.herokuapp.com/games")
      .then((res) => res.json())
      .then((data) => {
        setCards(data);
        setCardsToRender(data);
        setIsLoaded(true);
      });
  }, []);

  //listen on actualFilters change
  useEffect(() => {
    let allFiltersThatAreActive = {
      category: [],
      timeFrame: [],
      groupSize: [],
    };

    const { category, groupSize, timeFrame } = actualFilters;

    //simple for to iterate through objects
    for (let i in category) {
      if (category[i]) {
        allFiltersThatAreActive.category.push(i);
      }
    }

    for (let i in timeFrame) {
      if (timeFrame[i]) {
        allFiltersThatAreActive.timeFrame.push(i);
      }
    }

    for (let i in groupSize) {
      if (groupSize[i]) {
        allFiltersThatAreActive.groupSize.push(i);
      }
    }

    const filterKeys = Object.keys(allFiltersThatAreActive);

    let filteredCards = cards.filter((eachCard) => {
      return filterKeys.every((key) => {
        if (!allFiltersThatAreActive[key].length) {
          return true;
        }

        return allFiltersThatAreActive[key].includes(eachCard[key]);
      });
    });

    setCardsToRender(filteredCards);
  }, [actualFilters, cards]);

  //listen if there are all cards shown
  useEffect(() => {
    if (cardsToRender.length === cards.length) {
      setAllFilters(true);
    }
  }, [cardsToRender.length, cards]);

  //toggle active class on the filters buttons
  const toggleFilters = (e) => {
    let dataFilter = e.target.dataset.filter,
      dataFilterName = e.target.dataset.filterName,
      dataActualFilterName = e.target.dataset.actualFilterName;

    //set the filters toggle / button active class
    setFilters((prevState) => ({
      ...prevState,
      [dataFilter]: {
        ...prevState[dataFilter],
        [dataFilterName]: !prevState[dataFilter][dataFilterName],
      },
    }));

    //set the actual filters in state
    setActualFilters((prevState) => ({
      ...prevState,
      [dataFilter]: {
        ...prevState[dataFilter],
        [dataActualFilterName]: !prevState[dataFilter][dataActualFilterName],
      },
    }));

    setAllFilters(false);
  };

  const toggleAll = () => {
    setAllFilters(true);

    //hide all filters on click on all
    setFilters({
      category: {
        Energii: false,
        Akcija: false,
        Inovacii: false,
        Liderstvo: false,
        Tim: false,
      },
      timeFrame: {
        five_thirty_minutes: false,
        thirty_sixty_minutes: false,
        sixty_hundredandtwenty_minutes: false,
        hundredandtwenty_twohundredandfourty_minutes: false,
      },
      groupSize: { two_ten: false, ten_fourty: false, fourty_plus: false },
    });

    //hide all actual filters on click on all
    setActualFilters({
      category: {
        Енергии: false,
        Акција: false,
        Иновации: false,
        Лидерство: false,
        Тим: false,
      },
      timeFrame: {
        "5-30 минути": false,
        "30-60 минути": false,
        "60-120 минути": false,
        "120-240 минути": false,
      },
      groupSize: { "2-10": false, "10-40": false, "40+": false },
    });
  };

  return (
    <Router>
      <div className="App">
        <Header />
        <Route exact path="/" component={PosHeader} />
        {/* <Route exact path="/" component={ButtonsHeader } style={{ display: "none" }}/> */}
        <ButtonsHeader style={{ display: "none" }} />
        <Route exact path="/" render={(props) => <AssessTop {...props} />} />
        <Route
          exact
          path="/"
          render={(props) => (
            <Filters
              toggleFilters={toggleFilters}
              filters={filters}
              actualFilters={actualFilters}
              allFilters={allFilters}
              toggleAll={toggleAll}
            />
          )}
        />
        <Switch>
          <Route
            exact
            path="/"
            render={(props) => (
              <Cards {...props} cards={cardsToRender} isLoaded={isLoaded} />
            )}
          />
          <Route
            path="/description-game/:id"
            render={(props) => <DescriptionGame {...props} />}
          />
          <Route component={NoMatch} />
        </Switch>
        <AssessBottom />
        <Footer />
      </div>
    </Router>
  );
}

export default App;
